import { type ReactNode } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '@rolefit/shared/react';
import { Button, cn } from '@rolefit/ui';

const NAV = [
  { to: '/', label: 'Pipeline', end: true },
  { to: '/board', label: 'Board' },
  { to: '/outreach', label: 'Outreach' },
  { to: '/settings', label: 'Settings' },
];

function toggleTheme() {
  document.documentElement.classList.toggle('dark');
}

export function AppShell({ children }: { children: ReactNode }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen">
      <aside className="flex w-56 shrink-0 flex-col border-r bg-card p-4">
        <div className="mb-6 px-2 text-lg font-semibold tracking-tight">Rolefit</div>
        <nav className="flex flex-col gap-1">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                cn(
                  'rounded-md px-3 py-2 text-sm font-medium transition-colors',
                  isActive ? 'bg-secondary text-secondary-foreground' : 'text-muted-foreground hover:bg-accent',
                )
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="mt-auto flex flex-col gap-2 pt-4">
          <Button variant="ghost" size="sm" onClick={toggleTheme}>
            Toggle theme
          </Button>
          <div className="truncate px-3 text-xs text-muted-foreground" title={user?.email}>
            {user?.email}
          </div>
          <Button
            variant="outline"
            size="sm"
            onClick={async () => {
              await logout();
              navigate('/login', { replace: true });
            }}
          >
            Sign out
          </Button>
        </div>
      </aside>
      <main className="flex-1 overflow-y-auto">{children}</main>
    </div>
  );
}
